import React from 'react';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { SolutionSection } from './components/SolutionSection';
import { ValueStackSection } from './components/ValueStackSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { StickyFooter } from './components/StickyFooter';
export function App() {
  return <div className="min-h-screen bg-slate-50 font-sans text-slate-900 selection:bg-brand-200 selection:text-brand-900" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <PainSection data-id="element-3" />
        <SolutionSection data-id="element-4" />
        <ValueStackSection data-id="element-5" />
        <BonusSection data-id="element-6" />
        <PricingSection data-id="element-7" />
        <TestimonialsSection data-id="element-8" />
        <GuaranteeSection data-id="element-9" />
        <FAQSection data-id="element-10" />
      </main>
      <StickyFooter data-id="element-11" />
    </div>;
}